import React, { useState } from "react";
import { signUp } from "../../store/user/actions";
// import { selectToken } from "../../store/user/selectors";
import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";

export default function SignUp(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  // const token = useSelector(selectToken);
  // const history = useHistory();

  // useEffect(() => {
  //   if (token !== null) {
  //     history.push("/");
  //   }
  // }, [token, history]);

  function submitForm(event) {
    event.preventDefault();

    dispatch(signUp(name, email, password));

    setEmail("");
    setPassword("");
    setName("");
  }

  return (
    <div class="login">
      <div
        style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}
      >
        <div style={{ color: "white" }} onClick={() => props.closeModal()}>
          x
        </div>
      </div>
      <h1> New Account </h1>

      <div class="username">
        <input
          type="text"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Enter your name"
        ></input>
      </div>

      <div class="username">
        <input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          type="text"
          placeholder="Email"
          required
        ></input>
      </div>

      <div class="password">
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        ></input>
      </div>

      <input
        type="submit"
        value="Create an account"
        onClick={submitForm}
      ></input>
      <div>
        <p>Do you already have an account?</p>
        <button onClick={props.loadLogin}>Go to login</button>
      </div>
    </div>
  );
}
